(() => {
  const instances = new WeakMap();
  function mount(root) {
    if (instances.has(root)) return;
    const events = new AbortController();
    const duration = Math.max(0, Number(root.dataset.countdown) || 0);
    const deadline = Date.now() + duration * 1000;
    function tick() {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const values = { hours: Math.floor(remaining / 3600), minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      root.querySelectorAll('[data-bf-timer]').forEach(el => {
        el.textContent = String(values[el.dataset.bfTimer]).padStart(2, '0');
      });
    }
    const loadVideo = video => {
      if (video.dataset.src) {
        video.poster = video.dataset.poster || '';
        video.src = video.dataset.src;
        delete video.dataset.src;
      }
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(({ target: video, isIntersecting }) => {
        if (isIntersecting) {
          loadVideo(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { rootMargin: '100px 0px' }) : null;
    tick();
    instances.set(root, { timer: setInterval(tick, 1000), observer, events });
    root.querySelectorAll('[data-bf-video]').forEach(wrapper => {
      const video = wrapper.querySelector('video');
      const button = wrapper.querySelector('[data-bf-toggle]');
      if (!video) return;
      if (button) {
        const sync = () => {
          button.setAttribute('aria-label', video.paused ? 'Play' : 'Pause');
          button.setAttribute('aria-pressed', String(!video.paused));
          button.querySelector('svg').style.opacity = video.paused ? '.5' : '1';
        };
        button.addEventListener('click', () => {
          if (video.paused) { loadVideo(video); video.play().catch(sync); }
          else video.pause();
        }, { signal: events.signal });
        video.addEventListener('play', sync, { signal: events.signal });
        video.addEventListener('pause', sync, { signal: events.signal });
        sync();
      }
      if (observer) observer.observe(video);
      else loadVideo(video);
    });
  }
  function unmount(root) {
    const state = instances.get(root);
    if (!state) return;
    clearInterval(state.timer);
    state.observer?.disconnect();
    state.events.abort();
    instances.delete(root);
  }
  document.querySelectorAll('[data-bf-copy]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bf-copy]').forEach(mount));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bf-copy]').forEach(unmount));
})();
